<div class="modal-header">
  <div class="title">
    <!-- <h2 class="modal-title-prefix"><span translate="EDOKUMENT.SEND.SINGULAR"></span></h2> -->
     <h2 class="modal-title-prefix" *ngIf="isOtpremnica"><span
                            translate="EOTPREMNICA.SEND.SINGULAR"></span></h2>
      <h2 class="modal-title-prefix" *ngIf="!isOtpremnica"><span
              translate="EPRIJEMNICA.SEND.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">


  <div class="row detail-table">
    <div class="col-md-12">
      <yt-fw-default-table *ngIf="modelData!=null && modelData.MainList!=null"
                           [Config]="Config"
                           [Items]="items"
                           [TableColumns]="modelData.MainList.TableColumns"
                           [Condensed]="CondensedTable"
                           [ShowLoader]="MainItemsLoading"
                           (DeleteItemClicked)="deleteItem($event)">
      </yt-fw-default-table>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-3">
      <div class="btn-group ml-auto mr-2">
        <input #file type="file" accept="application/pdf" multiple (change)="onFileChange($event)" style="display:none" />
        <button type="button" class="btn btn-outline-primary" id="btnAddAttachment" (click)="file.click()" [disabled]="!file">
          <i class="fas fa-solid fa-paperclip"></i>
          <span translate="EDOKUMENT.ATTACHMENT.ADD"></span>
        </button>
      </div>
    </div>
  </div>
  

</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" id="btnSendEdokument" (click)="SendEDokument()">
    <span *ngIf="isOtpremnica">
      <span translate="EOTPREMNICA.SEND.ACTION"></span>
    </span>
    <span *ngIf="!isOtpremnica">
      <span translate="EPRIJEMNICA.SEND.ACTION"></span>
    </span>
    <span *ngIf="loadingSendEUDespatch" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
  </button>
  <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span translate="FW.ACTION.CLOSE.ACTION"></span></button>
</div>
